import GatewayApiClient from '../libs/gateway-api-client';

let loader;

export default {
  namespaced: true,
  state     : () => ({
    coin  : null,
    point : null,
    coupon: null,
  }),
  getters: {
    loaded: (state) => (state.coin != null || state.point != null || state.coupon != null),
  },
  mutations: {
    setBalance(state, { balance }) {
      state.coin = balance.coin;
      state.point = balance.point;
      state.coupon = balance.coupon;
    },
  },
  actions: {
    fetchWallet({ commit, state, getters }) {
      // ロード済み
      if (getters.loaded) {
        return Promise.resolve();
      }
      // ロード中
      if (loader) {
        return loader;
      }
      // 新規ロード
      return loader = new GatewayApiClient(this._vm.$fetch).getWalletBalance()
        .then((balance) => {
          loader = null;
          commit('setBalance', { balance });
        })
        .catch((error) => {
          loader = null;
          throw error;
        });
    },
  },
};
